/**
 * Animations.js
 * Handles scroll-based animations using Alpine.js Observer
 */

/**
 * Initialize fade animations for elements with the 'a-fade' class
 * Uses Alpine.js Observer to trigger animations when elements enter and exit viewport
 */
export function initFadeAnimations() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('fadeAnimation', (options = {}) => ({
      visible: false,
      static: options.static === true, // Default to false

      init() {
        console.log('Static:', this.static);
        // If static, just fade in immediately
        if (this.static) {
          // Small delay to ensure element is rendered
          setTimeout(() => {
            this.visible = true;
          }, 100);
          return; // Exit early, no observer needed
        }

        // Regular intersection observer - always non-reversible
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.visible = true;
                // Stop observing after first trigger
                observer.unobserve(this.$el);
              }
            });
          },
          {
            root: null,
            threshold: 0.1,
            rootMargin: '0px',
          }
        );

        observer.observe(this.$el);
      },
    }));
  });
}

/**
 * Add any additional animation types below
 */
